import "./BlogInfoCard.css";

function BlogInfoCard({ title, children, showicon = false, iconpath = "" }) {
  return (
    <div className="info-card">
      {showicon && (
        <div className="card-icon">
          <img src={iconpath || "add-user-line.png"} alt="icon" />
        </div>
      )}
      {title && <h3 className="info-card-title">{title}</h3>}
      <div className="info-card-body">{children}</div>
    </div>
  );
}

export default BlogInfoCard;